import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

const mutation = gql`
  mutation jobSignOffRequest(
    $cloudId: String!
    $signOffRequestedFromUserId: String!
  ) {
    jobSignOffRequest(
      input: {
        cloudId: $cloudId
        signOffRequestedFromUserId: $signOffRequestedFromUserId
      }
    ) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/jobSignOffRequest').type;

export type JobSignOffRequestVariables = OperationVariables<typeof mutation>;
export type JobSignOffRequestResult = OperationData<typeof mutation>;

export const useJobSignOffRequest = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'GetJob',
          'GetJobComments',
          'GetNotificationCountForUser',
        ],
        // refetchQueries: [
        //   {
        //     query: getJobQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        //   {
        //     query: getJobCommentsQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        // ],
        awaitRefetchQueries: true,
        update(cache) {
          cache.evict({ fieldName: 'getJobSignOffs' });
        },
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
